import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import {
	AreaChart,
	Area,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip as RechartsTooltip,
	ResponsiveContainer,
	Legend,
} from "recharts";
import { Card, CardTitle } from "./styled";
import { PALETTE } from "./constants";
import { tooltipStyle } from "./constants";
import { IStatVBarChart, IStatItem } from "./types";

export const AreaChartCard = ({ item }: { item: IStatItem }) => {
	useLocale();
	const rawData = item.data as IStatVBarChart[];
	const hasMultiple = rawData.length > 0 && Array.isArray(rawData[0].value);
	const colors = item.colors ?? PALETTE;

	let chartData: Record<string, string | number>[];
	let seriesKeys: string[];

	if (hasMultiple) {
		const maxLen = Math.max(...rawData.map(d => (d.value as number[]).length));
		seriesKeys = Array.from({ length: maxLen }, (_, i) => msg("templateSeries_f1988812", { v0: i + 1 }));
		chartData = rawData.map(d => {
			const obj: Record<string, string | number> = { label: d.label };
			(d.value as number[]).forEach((v, i) => {
				obj[`s${i}`] = v;
			});
			return obj;
		});
	} else {
		seriesKeys = ["Value"];
		chartData = rawData.map(d => ({ label: d.label, s0: d.value as number }));
	}

	return (
		<Card>
			<CardTitle>{item.title}</CardTitle>
			<ResponsiveContainer width="100%" height={280}>
				<AreaChart data={chartData} margin={{ top: 10, right: 10, left: -10, bottom: 0 }}>
					<defs>
						{seriesKeys.map((_, i) => (
							<linearGradient key={i} id={`grad_area_${i}`} x1="0" y1="0" x2="0" y2="1">
								<stop offset="0%" stopColor={colors[i % colors.length]} stopOpacity={0.2} />
								<stop offset="100%" stopColor={colors[i % colors.length]} stopOpacity={0} />
							</linearGradient>
						))}
					</defs>
					<CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" vertical={false} />
					<XAxis dataKey="label" tick={{ fontSize: 12, fill: "#848799" }} axisLine={false} tickLine={false} />
					<YAxis tick={{ fontSize: 12, fill: "#848799" }} axisLine={false} tickLine={false} />
					<RechartsTooltip contentStyle={tooltipStyle} />
					{seriesKeys.map((key, i) => (
						<Area
							key={i}
							type="monotone"
							dataKey={`s${i}`}
							name={key}
							stroke={colors[i % colors.length]}
							strokeWidth={2.5}
							fill={`url(#grad_area_${i})`}
							dot={false}
							activeDot={{ r: 5, strokeWidth: 2, fill: "#fff" }}
						/>
					))}
					{seriesKeys.length > 1 && <Legend wrapperStyle={{ fontSize: 12 }} />}
				</AreaChart>
			</ResponsiveContainer>
		</Card>
	);
};
